import React from 'react';
import { cn } from '../../lib/utils';

interface ProgressBarProps {
  value: number; // 0-100
  className?: string;
  color?: 'green' | 'blue' | 'orange' | 'red' | 'auto';
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function ProgressBar({
  value,
  className,
  color = 'auto',
  showLabel = false,
  size = 'sm',
}: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  const sizeMap = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3',
  };

  let barStyle = '';
  if (color === 'auto') {
    barStyle =
      clamped >= 75 ? 'bg-[#16A34A]' :
      clamped >= 40 ? 'bg-[#2563EB]' :
      clamped >= 15 ? 'bg-[#F97316]' :
      'bg-[#DC2626]';
  } else {
    const colorMap: Record<string, string> = {
      green: 'bg-[#16A34A]',
      blue: 'bg-[#2563EB]',
      orange: 'bg-[#F97316]',
      red: 'bg-[#DC2626]',
    };
    barStyle = colorMap[color];
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className={cn('flex-1 bg-[#E4E4E7] rounded-full overflow-hidden', sizeMap[size])}>
        <div
          className={cn('h-full rounded-full transition-all duration-500', barStyle)}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs font-semibold text-[#71717A] w-9 text-right tabular-nums">{clamped}%</span>
      )}
    </div>
  );
}
